import React, { useEffect, useState } from 'react'

import { SingleSelect } from '../Select'

import apiClient from '../../helpers/apiClient'

const SingleCountrySelect = ({ country, onSelectCountry, validationError }) => {
  const [countryList, setCountryList] = useState([])

  useEffect(() => {
    apiClient
      .get(`/countries`)
      .then((res) => {
        setCountryList(
          res?.data?.data?.map((e) => ({
            value: e.name,
            label: e.name,
          }))
        )
      })
      .catch((err) => console.log(err))
  }, [])

  return (
    <SingleSelect
      title="Country"
      selected={country}
      options={countryList}
      placeholder="Start typing a country..."
      onChange={onSelectCountry}
      wrapperClass={validationError && 'error'}
      subText={validationError}
    />
  )
}

export default SingleCountrySelect
